import { useSpring } from '@react-spring/web';
export default () => {
    const [style, api] = useSpring(() => ({
        opacity: 0.7,
    }));
    const onMouseLeave = () => {
        api.start({ opacity: 0.7 });
    };
    const onMouseEnter = () => {
        api.start({ opacity: 1 });
    };
    const bind = () => {
        return {
            onMouseLeave,
            onMouseEnter,
            style,
        };
    };
    return {
        bind,
        style,
    };
};
